/* globals grecaptcha */
import $ from 'jquery';
import Cookies from 'js-cookie';
import 'whatwg-fetch';
import sketches from './signature';

$('input[type=radio]').on('change', e => {
  $(`input[name="${e.target.name}"]:not(:checked)`)
      .siblings('.nested')
      .find('input')
      .attr('disabled', true);
  $(e.target)
      .siblings('.nested')
      .children('div')
      .children('input')
      .attr('disabled', false)
      .trigger('change');
  $(e.target)
      .siblings('.nested')
      .children('div')
      .children('div')
      .children('input')
      .attr('disabled', false)
      .trigger('change');
});

$('input[type=checkbox]').on('change', e => {
  $(e.target)
      .siblings('.nested')
      .children('div')
      .children('input')
      .attr('disabled', !e.target.checked)
      .trigger('change');
  $(e.target)
      .siblings('.nested')
      .children('div')
      .children('div')
      .children('input')
      .attr('disabled', !e.target.checked)
      .trigger('change');
});

$('.questionTitle,.questionSubtitle').on('click', e => {
  $(e.target)
      .parent()
      .siblings('input[type="radio"],input[type="checkbox"]')
      .click();
});

$('form').on('submit', () => {
  // check required
  if (requiredCheck()) {
    grecaptcha.execute();
  } else {
    // show missing information
    $('html, body').animate({
      scrollTop: $('.redBorder').offset().top - 120,
    }, 500);
  }
  // Prevent default form submit
  return false;
});

function getDataFromForm() {
  // finde alle element-ids
  const data = {};
  const ids = $('[element-id]').toArray().map(ele => $(ele).attr('element-id')).reduce(uniqueFilter, []);

  for (const eleId of ids) {
    if ($(`[element-id="${eleId}"]`).prop('disabled')) { // ignore disabled elements
      continue;
    }

    if ($(`[element-id="${eleId}"]`).hasClass('signature')) {
      const s = sketches[eleId];
      data[eleId] = s.lines.map(line => line.map(p => ({ x: p.x, y: p.y })));
      continue;
    }

    if (['radio', 'checkbox'].includes($(`[element-id="${eleId}"]`).prop('type'))) {
      data[eleId] = $(`[element-id="${eleId}"]:checked`).toArray().map(ele => $(ele).val());
      continue;
    }

    if ($(`input[element-id="${eleId}"], textarea[element-id="${eleId}"], select[element-id="${eleId}"]`).length > 0) {
      data[eleId] = $(`[element-id="${eleId}"]`).toArray().map(ele => $(ele).val().trim());
      continue;
    }

    if ($(`p[element-id="${eleId}"], hr[element-id="${eleId}"]`).length > 0) continue;
    console.error(`Could not read data from :[element-id="${eleId}"]`);
  }
  return { content: data, formId: $('form').attr('form-id') };
}

function uniqueFilter(ids, id, i, arr) {
  return (arr.indexOf(id) == i ? [...ids, id] : ids);
}

function requiredCheck() {
  $('.redBorder').removeClass('redBorder');
  let passReq = true;
  const reqElements = $('.required:not(:disabled)').toArray();
  for (const ele of reqElements) {
    if ($(ele).hasClass('signature')) {
      const eleId = $(ele).attr('element-id');
      const s = sketches[eleId];
      if (s.lines.length == 0) {
        $(ele).find('canvas').addClass('redBorder');
        passReq = false;
      }
      continue;
    }

    const inputs = ['textarea', 'input[type="text"]', 'input[type="fname"]', 'input[type="lname"]',
      'input[type="email"]', 'input[type="tel"]', 'input[type="time"]', 'input[type="date"]', 'input[type="datetime-local"]'];
    if ($(ele).is(inputs.join(','))) {
      if ($(ele).val().trim() == '') {
        $(ele).addClass('redBorder');
        const removeBorder = () => {
          $(ele).removeClass('redBorder');
          $(ele).off('input', removeBorder);
        };
        $(ele).on('input', removeBorder);
        passReq = false;
      }
      continue;
    }

    if ($(ele).is('input[type="radio"],input[type="checkbox"]')) {
      const name = $(ele).prop('name');

      if ($(`input[name="${name}"]:checked`).length == 0) {
        const container = $(ele).closest('.nested');
        if (container.length > 0) container.addClass('redBorder');
        else $(ele).closest('.tile').addClass('redBorder');

        const removeBorder = () => {
          $(ele).closest('.redBorder').removeClass('redBorder');
          $(ele).off('input', removeBorder);
        };
        $(ele).on('input', removeBorder);
        passReq = false;
      }
      continue;
    }
  }
  return passReq;
}

// eslint-disable-next-line no-unused-vars
window.submitForm = token => { // token is for recaptcha
  // send data form data
  const confirmationMail = $('#confirmationMail').val();
  const data = { ...getDataFromForm(), token, confirmationMail };
  $('button[type="submit"]').prop('disabled', true);
  fetch('/api/send', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'CSRF-Token': Cookies.get('XSRF-TOKEN'),
    },
  })
      .then(res => new Promise((resolve, reject) => res.json().then(responseJson => resolve({ res, responseJson })).catch(err => reject(err))))
      .then(({ res, responseJson }) => {
        console.log(res);
        console.log(responseJson);

        if (res.status == 200 && responseJson.result == 'redirect' && responseJson.url) {
          $(window).off('beforeunload');
          window.location.replace(responseJson.url);
        } else {
          const msg = (responseJson || {}).message
          || 'Leider ist ein unerwarteter Fehler aufgetreten. Das Team von schule&#8209;formular wurde soeben darüber informiert.';
          $('p.fehlermeldung').html(msg);
          $('.fehlermeldungDiv').removeClass('hidden');
        }
      })
      .catch(err => {
        console.error(err);
        const msg = 'Leider ist ein unerwarteter Fehler aufgetreten. Das Team von schule&#8209;formular wurde soeben darüber informiert.';
        $('p.fehlermeldung').html(msg);
        $('.fehlermeldungDiv').removeClass('hidden');
      });
};

$(window).on('beforeunload', () => {
  const content = getDataFromForm().content;
  const isDropdown = id => $(`select[element-id="${id}"]`).length == 1;
  const data = Object.keys(content || {})
      .filter(key => !isDropdown(key))
      .flatMap(key => content[key]).join('')
      .trim();
  if (data != '') return true;
});
